module.exports = __webpack_public_path__ + "media/svg-new/lock2-b1523a05.svg";